import Component from '@bythepixel/component-loader';
import { Map, NavigationControl } from 'mapbox-gl';
import LngLat from './lngLat';
import LngLatBounds from './lngLatBounds';
import MapMarker from './mapMarker';

export default class MapView extends Component {
  static selector = '[data-comp-map]'
  #map
  #bounds
  #markers = []
  #visibleMarkers = {}

  constructor(...args) {
    super(...args);
    this.#bounds = new LngLatBounds(undefined, undefined);
    this._createMapboxMap();
    this.#map.addControl(new NavigationControl());
  }

  get() {
    return this.#map;
  }

  _createMapboxMap() {
    this.#map = new Map({
      accessToken: 'pk.eyJ1IjoiY2ltYXJyb250cmFpbGVycyIsImEiOiJja21lYzJpZWowYTIxMnZvM20xdGdiOThhIn0.O6sNFGLk3Wo7ZiYFZkdN2w',
      container: this.$container,
      // Options: https://docs.mapbox.com/api/maps/#mapbox-styles
      style: 'mapbox://styles/mapbox/outdoors-v11',
      // interactive: false,
      fitBoundsOptions: {
        padding: {
          top: 80,
          left: 20,
          right: 20,
          bottom: 20,
        },
      },
      AnimationOptions: {
        animate: false,
      },
      PaddingOptions: {
        top: 80,
        left: 20,
        right: 20,
        bottom: 20,
      },
      // scrollZoom: false,
      // boxZoom: false,
    });
  }

  addMarker(data) {
    if (!this.#markers[data.id]) {
      const latLng = new LngLat(data.latitude, data.longitude);
      this.#bounds.add(latLng.get());
      this.#markers[data.id] = new MapMarker(data, this.#map);
    }
    this.#markers[data.id].getMarker().addTo(this.#map);
    this.#visibleMarkers[data.id] = this.#markers[data.id];
    return this.#markers[data.id];
  }

  removeMarker(data) {
    if (this.#markers[data.id]) {
      this.#markers[data.id].getMarker().remove();
      delete this.#visibleMarkers[data.id];
    }
  }

  fitBounds(bounds = this.#bounds.get()) {
    this.#map.resize();
    this.#map.fitBounds(bounds, { padding: 100, maxZoom: 10 });
  }

  fitBoundsToVisible() {
    const bounds = new LngLatBounds(undefined, undefined);

    Object.values(this.#visibleMarkers).forEach((marker) => {
      bounds.add(marker.getLngLat());
    });

    this.fitBounds(bounds.get());
  }

  flyTo(options) {
    this.#map.flyTo(options);
  }

  setCenter(lat, lng) {
    this.#map.setCenter(new LngLat(lat, lng).get());
  }

  setZoom(z) {
    this.#map.setZoom(z);
  }

  on(event, cb) {
    this.#map.on(event, cb);
  }
}
